import { ISoDiemMapping } from './../models/response/so-diem/ISoDiemMapping';
import { ISoDiemUpdateMoetRequest } from './../models/request/so-diem/ISoDiemUpdateMoetRequest';
import { apiClient } from './apiClient';

export const soDiemMappingApi = {
    loadBySoDiem: (soDiemId: number) => apiClient.get(`so-diem/${soDiemId}/mapping`),
    updateMoet: (request: ISoDiemUpdateMoetRequest) => apiClient.put(`so-diem/moet`, request),
    saveMapping: (request: ISoDiemMapping) => apiClient.post(`so-diem/mapping`, request)
}